import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import { ArrowUpIcon, ArrowDownIcon, UserIcon, ChartBarIcon } from "@heroicons/react/outline";

// Chart.js Registration
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// Dummy Data for Charts
const lineData = {
  labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
  datasets: [
    {
      label: "Revenue",
      data: [2000, 4000, 3000, 5000, 7000, 6000, 8000],
      borderColor: "rgba(99, 102, 241, 1)",
      backgroundColor: "rgba(99, 102, 241, 0.2)",
      tension: 0.4,
      fill: true,
    },
  ],
};

const barData = {
  labels: ["Product A", "Product B", "Product C", "Product D", "Product E"],
  datasets: [
    {
      label: "Sales",
      data: [120, 200, 150, 80, 70],
      backgroundColor: [
        "rgba(99, 102, 241, 0.7)",
        "rgba(34, 197, 94, 0.7)",
        "rgba(239, 68, 68, 0.7)",
        "rgba(234, 179, 8, 0.7)",
        "rgba(59, 130, 246, 0.7)",
      ],
      borderColor: "rgba(255, 255, 255, 1)",
      borderWidth: 1,
    },
  ],
};

export default function Dashboard() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
    
      {/* Main Content */}
      <main className="py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Cards */}
          <div className="bg-white p-6 rounded-lg shadow">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-medium text-gray-700">Total Users</h3>
                <p className="text-3xl font-bold text-gray-900 mt-2">12,345</p>
              </div>
              <UserIcon className="w-10 h-10 text-blue-500" />
            </div>
            <p className="text-sm text-green-600 mt-4 flex items-center">
              <ArrowUpIcon className="w-4 h-4 mr-1" />
              +10% from last month
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-medium text-gray-700">Revenue</h3>
                <p className="text-3xl font-bold text-gray-900 mt-2">$45,678</p>
              </div>
              <ChartBarIcon className="w-10 h-10 text-green-500" />
            </div>
            <p className="text-sm text-red-600 mt-4 flex items-center">
              <ArrowDownIcon className="w-4 h-4 mr-1" />
              -5% from last month
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-medium text-gray-700">New Signups</h3>
                <p className="text-3xl font-bold text-gray-900 mt-2">678</p>
              </div>
              <UserIcon className="w-10 h-10 text-yellow-500" />
            </div>
            <p className="text-sm text-green-600 mt-4 flex items-center">
              <ArrowUpIcon className="w-4 h-4 mr-1" />
              +20% from last month
            </p>
          </div>
        </div>

        {/* Charts Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-6 mt-10">
          {/* Line Chart */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-medium text-gray-700 mb-4">Revenue Over Time</h3>
            <Line data={lineData} />
          </div>

          {/* Bar Chart */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-medium text-gray-700 mb-4">Product Sales</h3>
            <Bar data={barData} />
          </div>
        </div>
      </main>
    </div>
  );
}
